import { render, staticRenderFns } from "./medical-analyses-sidesheet.vue?vue&type=template&id=d8585814&scoped=true&"
import script from "./medical-analyses-sidesheet.vue?vue&type=script&lang=js&"
export * from "./medical-analyses-sidesheet.vue?vue&type=script&lang=js&"
import style0 from "./medical-analyses-sidesheet.vue?vue&type=style&index=0&id=d8585814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8585814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8585814')) {
      api.createRecord('d8585814', component.options)
    } else {
      api.reload('d8585814', component.options)
    }
    module.hot.accept("./medical-analyses-sidesheet.vue?vue&type=template&id=d8585814&scoped=true&", function () {
      api.rerender('d8585814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/medical-analyses/medical-analyses-sidesheet.vue"
export default component.exports